import { Tienda } from '../tiendas/tienda';

export class Subcategoria {
  id: number;
  nombre: string;
  imagen: string;
  orden: string;
  tiendas?: Array<Tienda>;

  constructor(item: any) {
    this.id      = item.id_subcategoria;
    this.nombre  = item.nombre_subcategoria;
    this.imagen  = item.imagen_subcategoria;
    this.orden   = item.orden_subcategoria;
  }
}
